import { ArrowDown, ArrowRight, Clock, MapPin } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export const Hero = () => (
  <section id="top" className="hero" data-testid="hero-section">
    <div className="hero-image" role="img" aria-label="Close overhead view of a barge fleeting area on Gulf Coast waters" />
    <div className="hero-grid" aria-hidden="true" />
    <div className="hero-content">
      <motion.div
        className="eyebrow hero-eyebrow"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-testid="hero-location-label"
      >
        <MapPin size={16} weight="fill" /> Corpus Christi, Texas
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.75, delay: 0.1 }}
        data-testid="hero-heading"
      >
        Ready water.<br /><em>Reliable hands.</em>
      </motion.h1>
      <motion.p
        className="hero-copy"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.22 }}
        data-testid="hero-description"
      >
        Fleeting and marine support built around the operators, schedules, and working waters of the Texas Gulf Coast.
      </motion.p>
      <motion.div
        className="hero-actions"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65, delay: 0.34 }}
      >
        <a className="button button-orange" href="#contact" data-testid="hero-request-quote-button">
          Request a quote <ArrowRight size={19} weight="bold" />
        </a>
        <a className="button button-ghost" href="#services" data-testid="hero-explore-services-button">
          Explore services <ArrowDown size={19} weight="bold" />
        </a>
      </motion.div>
    </div>
    <div className="hero-status" data-testid="hero-operations-status">
      <Clock size={22} weight="fill" />
      <div><span>Operations requests</span><strong>Accepted 24 / 7</strong></div>
    </div>
  </section>
);